import React from 'react';
import styled from "styled-components/macro";
import {AnimatePresence, motion} from "framer-motion";
import colors from "../../styles/variables/colors";
import {StatusIndicatorInterface} from "./interfaces";

export const StatusIndicatorWrapper = styled(motion.div)`
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-wrap: nowrap;
`;

export const StatusIndicatorElement = styled(motion.div)`
  height: 100%;
  width: 100%;
`;

type StatusIndicatorComponent = (props: StatusIndicatorInterface) => JSX.Element;

const StatusIndicator: StatusIndicatorComponent = ({elements = 3, type = 'flat'}) => {

  return (
    <StatusIndicatorWrapper>
      <AnimatePresence>
        {elements === 2 ?
          (
            <motion.div
              style={{ width: "100%", background: `linear-gradient(to right, ${colors.orange.base} 0 50%, ${colors.yellow.base} 50% 100%)`}}
            />
          ) : (
            <motion.div
              key={'animated_colors'}
              initial={{background: `linear-gradient(to right, ${colors.orange.base} 0 50%, ${colors.yellow.base} 50% 100%, ${colors.blue.base} 100% 100%)`}}
              animate={{background: `linear-gradient(to right, ${colors.orange.base} 0 33%, ${colors.yellow.base} 33% 66%, ${colors.blue.base} 66% 100%)` }}
              transition={{ ease: 'anticipate', duration: 0.6 }}
              style={{width: "100%"}}
            />
          )
        }
      </AnimatePresence>
    </StatusIndicatorWrapper>
  )

}

export default StatusIndicator;
